<template>
	<div id="question-background" v-bind:class="!showAnswer ? 'showing-question': 'showing-answer'">
		<div id="question-popup" class="q-multiple" v-bind:class="`qa-${which}-${tabType} cur-q-${curQ}`">



			<div id="question-choices" v-if="!showAnswer" class="qa-container">
				<h3>{{content[which].InterimQA[curQ].question}}</h3>
				<ul id="choices" v-bind:class="content[which].InterimQA[curQ].layoutClass ? content[which].InterimQA[curQ].layoutClass: ''">
					<li v-for="(choice, index) in content[which].InterimQA[curQ].choices" v-bind:key="index">
						<label>
							<input v-if="content[which].InterimQA[curQ].type === 'radio'" v-bind:id="`choice-${index}`" v-bind:type="content[which].InterimQA[curQ].type" v-bind:name="which" v-bind:value="index" v-model="choices" /> 
							<input v-else v-bind:id="`choice-${index}`" v-bind:type="content[which].InterimQA[curQ].type" v-bind:name="`${which}-${index}`" v-bind:value="index" v-model="choices" /> 
							<span class="radio-checkbox"></span>
							<span class="copy" v-if="content[which].InterimQA[curQ].keepBR" v-html="choice"></span>
							<span class="copy" v-else>{{stripBR(choice)}}</span>
						</label>
					</li>
				</ul>
				<div id="button-submit-container">
					<div v-if="!selection" id="button-prevent"></div>
					<img v-on:click="getAnswer" id="button-submit" width="139" height="53" src="../assets/global/button-submit.png" />
				</div>
			</div>
			<div v-else id="answer-to-question" class="qa-container">

				<div v-if="!content[which].InterimQA[curQ].showTabs" >
					<div id="answer-hdr" v-if="!content[which].InterimQA[curQ].altAnswer">
						<h3>
							<span class="ans">Answer: </span> 
							<span v-if="!content[which].InterimQA[curQ].answerLong" v-html="content[which].InterimQA[curQ].choices[content[which].InterimQA[curQ].answer] + '.'">
							</span>
							<span v-else>
								{{content[which].InterimQA[curQ].answerLong}}
							</span>
						</h3>
						<div id="close" v-on:click="closeThen">
							<img width="24" src="../assets/global/close-button.png" alt="Close" />
						</div>	
					</div>
					<div id="answer-hdr" v-else>
						<h3>
							<span class="ans">Answer: </span> 
							<span>
								{{content[which].InterimQA[curQ].altAnswer}}
							</span>
						</h3>
						<div id="close" v-on:click="closeThen">
							<img width="24" src="../assets/global/close-button.png" alt="Close" />
						</div>	
					</div>
					<img v-bind:width="content[which].InterimQA[curQ].answerSize" v-bind:src="require(`@/assets/patients/${which}/${tabType}/${tabType}_${curQ}_answer.png`)" />
				</div>
				<div v-else id="tab-content-answer" v-bind:style="{'background-image': 'url(' + require(`@/assets/patients/${which}/${tabType}/${tabType}_${curQ}_answer.png`) + ')'}">

					<div id="answer-hdr" v-if="!content[which].InterimQA[curQ].altAnswer">
						<h3>
							<span class="ans">Answer: </span> 
							<span v-if="!content[which].InterimQA[curQ].answerLong" v-html="content[which].InterimQA[curQ].choices[content[which].InterimQA[curQ].answer] + '.'">
							</span>
							<span v-else>
								{{content[which].InterimQA[curQ].answerLong}}
							</span>
						</h3>
						<div id="close" v-on:click="closeThen">
							<img width="24" src="../assets/global/close-button.png" alt="Close" />
						</div>	
					</div>
					<TabbedContent
						v-bind:which="which"
						v-bind:tabType="content[which].whichTabbedContentAns"
					>
					</TabbedContent>




				</div>

			</div>
		</div>
	</div>
</template>
<script>
import TabbedContent from '@/components/TabbedContent.vue'
export default {
	components: {
		TabbedContent
	},
	emits: ['close-then'],
	props: {
		tabType: {
			type: String
		},
		which: {
			type: String
		},
		content: {
			type: Object
		}
	},
	data() {
		return {
			choices: [],
			curQ: 0,
			selection: false,
			showAnswer: false
		}
	},
	watch: {
		choices: function(val){
			if(val !== null){
				this.selection = true
			} else {
				this.selection = false
			}
		}
	},
	methods: {
		stripBR(copy){
			return copy.replace("<br>","")
		},
		getAnswer(){
			this.showAnswer = true
		},
		closeThen(){
			if(this.content[this.which].InterimQA[this.curQ].nextQ != null){
				this.curQ = this.content[this.which].InterimQA[this.curQ].nextQ
				this.showAnswer = false
				this.choices = null
			} else {
				this.$emit('close-then',this.content[this.which].InterimQA[this.curQ].redirect)
			}
		}
	}
}
</script>
<style scoped>
#question-background {
	display: flex;
	position: fixed;
	align-items: center;
	justify-content: center;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

	#question-background.showing-answer {
		background-color: rgba(228,231,234,.51);
	}

#question-popup {
	min-height: 708px;
}

.qa-container {
	font-family: Arial, Helvetica, sans-serif;
}

#question-choices {
	background: url(../assets/patients/background-question-popup.png) no-repeat;
	background-size: cover;
	bottom: 372px;
	transform: translateY(3.5%);
	padding: 16px 18px 0 21px;
	width: 957px;
	height: 252px;
}

	h3 {
		color: rgba(26,201,168);
		font-size: 2.045rem;
		font-weight: bold;
		line-height: 1.5;
		margin-bottom: 15px;
	}

		#choices {
			color: #fff;
			font-size: 1.5rem;
		}

			#choices li {
				line-height: 1.7;
				margin-bottom: 24px;
			}

				#choices li:last-child {
					margin-bottom: 0;
				}

			#choices li label {
				/* align-items: center; */
				align-items: flex-start;
				cursor: pointer;
				display: flex;
			}
				#choices li label .copy {
					padding-top: 3px;
				}

				#choices.carson-cycle-1 li:nth-child(3) label .copy,
				#choices.carson-cycle-1 li:nth-child(4) label .copy {
					padding-top: 0;
				}

				#choices.carson-cycle-2 {
					width: 104%;
				}

				#choices.two-col.carson-cycle-2 li:nth-child(1),
				#choices.two-col.carson-cycle-2 li:nth-child(3) {
					width: 49%;
				}

				#choices.two-col.carson-cycle-2 li:nth-child(2),
				#choices.two-col.carson-cycle-2 li:nth-child(4) {
					width: 51%;
				}


				#choices.two-col.gordon-cycle-4 li:nth-child(4) label .copy {
					margin-top: -5px;
					padding-top: 0;
				}

				#choices.two-col.gordon-cycle-4 li:nth-child(3) {
					margin-top: -24px;
				}

			#choices li input {
				opacity: .01;
				position: absolute;
				z-index: -1;
			}

			#choices .copy .br {
				display: none;
			}

			#choices li .radio-checkbox {
				background: url(../assets/global/radio-off.png) no-repeat;
				background-size: contain;
				display: inline-block;
				margin-right: 13px;
				transition: all 240ms ease-in-out;
				min-width: 25px;
				width: 25px;
				height: 25px;
			}

				#choices li input[type="radio"]:checked + .radio-checkbox,
				#choices li input[type="checkbox"]:checked + .radio-checkbox {
					background: url(../assets/global/radio-on.png) no-repeat;
					background-size: contain;
				}

			#choices.two-col {
				display: flex;
				flex-wrap: wrap;
			}

				#choices.two-col li {
					margin-bottom: 18px;
					width: 50%;
				}

					#choices.two-col li label {
						min-height: 42px;
					}

						#choices.two-col.checkboxes li label {
							min-height: 30px;
						}

						#choices.one-col.gordon-cycle-4 li {
							margin-bottom: 12px;
						}

					#choices.two-col span.copy {
						max-width: 87%;
						line-height: 1.3;
					}

				#choices.two-col.gordon-cycle-4 li label .copy {
					padding-top: 0;
				}
				
				#choices.two-col.gordon-cycle-4 li:nth-child(3) label .copy {
					margin-top: -3px;
				}

				#choices.two-col.gordon-cycle-4 li:nth-child(4) label .copy {
					margin-top: -2px;
				}


#button-submit-container {
	position: absolute;
	right: -5px;
	bottom: -9px;
}

	.two-col.gordon-cycle-4 + #button-submit-container {
		bottom: -24px;
	}
	
	#button-prevent {
		background-color: rgba(72, 72, 72,.39);
		border-radius: 9px;
		position: absolute;
		bottom: 7px;
		right: 5px;
		width: 130px;
		height: 44px;
	}

	#button-submit {
		cursor: pointer;
	}

#answer-hdr {
	position: absolute
}

#answer-to-question {
	position: relative;
	transform: translateY(1.6%);
}

	#answer-hdr {
		align-items: center;
		display: flex;
		justify-content: space-between;
		width: 100%;
		height: 84px;
		padding: 0 32px 0 21px;
	}

		.q-multiple.cur-q-1.qa-gordon-cycle-4 #answer-hdr {
			padding-top: 0;
			height: 109px;
		} 

	#close {
		cursor: pointer;
		padding: 9px;
	}

	#tab-content-answer {
		background-size: contain;
		background-position: center top;
		background-repeat: no-repeat;
		overflow: hidden;
		padding-top: 0;
		width: 957px;
		height: auto;
	}

	#answer-to-question h3 {
		color: #fff;
		font-weight: normal;
		line-height: 1.3;
		margin-bottom: 0;
		max-width: 93%;
	}
	
		#answer-to-question h3 span.ans {
			color: rgba(26,201,168);
			font-weight: bold;
		}
</style>